<!-- Template -->
<template>
    <div>
        <!-- Opened tickets -->
        <table class="table with-header tickets-open">
            <thead v-show="openTickets.length > 0">
                <tr>
                    <th>
                        <a @click.prevent="sortBy('id', true);">
                            <span
                                :class="{'icon-arrow-up':this.openIdOrder, 'icon-arrow-down': !this.openIdOrder, 'hidden':this.openDateClicked}"
                            ></span> Ticket / Hospital contact
                        </a>
                    </th>
                    <th>Status</th>
                    <th class="r" width="130">
                        <a @click.prevent="sortBy('date', true);">
                            <span
                                :class="{'icon-arrow-up':this.openDateOrder, 'icon-arrow-down': !this.openDateOrder, 'hidden':this.openIdClicked}"
                            ></span> Date opened
                        </a>
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="t in openTickets" :key="t.id">
                    <td>
                        <a
                            class="open-system"
                            @click.prevent="openT(t)"
                        >#{{t.id}} {{t.shortSummary}}</a>
                        <p v-if="t.createdInPortal">Raised by {{t.createdByContact}}</p>
                    </td>
                    <td>
                        <p>{{t.status}}</p>
                    </td>
                    <td class="r" width="130">
                        <p>{{t.date}}</p>
                    </td>
                </tr>
                <tr v-show="openTickets.length <= 0">
                    <td class="nobottomborder">
                        <p>Tickets do not exist.</p>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Closed tickets -->
        <div v-show="closedTickets.length > 0">
            <p class="closed-tickets-title">Closed tickets in the past 12 months:</p>
            <table class="table with-header tickets-closed">
                <thead>
                    <tr>
                        <!-- <th>Priority</th> -->
                        <th>
                            <a @click.prevent="sortBy('id', false);">
                                <span
                                    :class="{'icon-arrow-up':this.closedIdOrder, 'icon-arrow-down': !this.closedIdOrder, 'hidden':this.closedDateClicked}"
                                ></span> Ticket / Hospital contact
                            </a>
                        </th>
                        <th>Status</th>
                        <th class="r" width="130">
                            <a @click.prevent="sortBy('date', false);">
                                <span
                                    :class="{'icon-arrow-up':this.closedDateOrder, 'icon-arrow-down': !this.closedDateOrder, 'hidden':this.closedIdClicked}"
                                ></span> Date closed
                            </a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="t in closedTickets" :key="t.id">
                        <!-- <td>
                            <span class="priority no-color" :class="t.priorityClass">{{t.priority}}</span>
                        </td>-->
                        <td @click.prevent="openT(t)">
                            #{{t.id}} {{t.shortSummary}}
                            <p
                                class="light"
                                v-if="t.createdInPortal"
                            >Raised by {{t.createdByContact}}</p>
                        </td>
                        <td>
                            <p class="light">{{t.status}}</p>
                        </td>
                        <td class="r" width="130">
                            <p class="light">{{t.date}}</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <TicketDetailsReadOnly ref="ticketDetails" :showBack="false" />
    </div>
</template>

<!-- Script -->

<script>
    import moment from "moment";
    //import { TicketService } from "@/services/ticket-service";
    import TicketDetailsReadOnly from "@/components/Dialogs/TicketDetailsReadOnly";
    export default {
        name: "SystemTickets",
        components: {
            TicketDetailsReadOnly
        },
        props: ["system"],
        data() {
            return {
                openTickets: [],
                closedTickets: [],
                openIdOrder: false,
                openDateOrder: true,
                closedIdOrder: false,
                closedDateOrder: true,
                openDateClicked: true,
                openIdClicked: true,
                closedDateClicked: true,
                closedIdClicked: true
            };
        },
        watch: {
            system: {
                deep: true,
                immediate: true,
                handler(value) {
                    if (value) {
                        this.update();
                    }
                }
            }
        },
        computed: {
            ticketDetails() {
                return this.$refs.ticketDetails;
            }
        },
        created() {
            this.update();
        },

        methods: {
            update() {
                var tickets = this.system.supportTickets;

                if (tickets.length > 0) {
                    var openedTickets = tickets.filter(function(ticket) {
                        return ticket.statusId == 1;
                    });

                    var closedTickets = tickets.filter(function(ticket) {
                        if (ticket.statusId == 2) {
                            var difference =
                                moment().unix() - moment(ticket.dateClosed).unix();
                            if (difference < 31556926) {
                                return ticket;
                            }
                        }
                    });

                    this.openTickets = this.parseTicketArray(openedTickets);
                    this.closedTickets = this.parseTicketArray(closedTickets);
                }
            },

            parseTicketArray(array) {
                var parsedArray = [];

                for (var i = 0; i < array.length; i++) {
                    var t = {
                        createdByContact: array[i].createdByContact,
                        createdByContactID: array[i].createdByContactID,
                        date:
                            array[i].statusId == 1
                                ? moment(array[i].dateOpened).format("DD MMM YYYY")
                                : moment(array[i].dateClosed).format("DD MMM YYYY"),
                        description: array[i].description,
                        dhrNumber: array[i].dhrNumber,
                        id: array[i].id,
                        lastUpdated: moment(array[i].lastUpdated).format(
                            "DD MMM YYYY"
                        ),
                        ownerId: array[i].ownerId,
                        ownerName: array[i].ownerName,
                        priority: array[i].priority,
                        priorityID: array[i].priorityID,
                        productConfiguration: array[i].productConfiguration,
                        shortSummary: array[i].shortSummary,
                        status: array[i].status,
                        statusId: array[i].statusId,
                        supportTicketNature: array[i].supportTicketNature,
                        supportTicketNatureId: array[i].supportTicketNatureId,
                        systemOperable: array[i].systemOperable,
                        priorityClass: "",
                        createdInPortal: array[i].createdInPortal,
                        contactEmail: array[i].contactEmail
                    };

                    if (array[i].priorityID == 3) {
                        t.priorityClass = " low";
                    } else if (array[i].priorityID == 2) {
                        t.priorityClass = " medium";
                    } else if (array[i].priorityID == 1) {
                        t.priorityClass = " high";
                    } else {
                        t.priorityClass = " medium";
                    }

                    parsedArray.push(t);
                }

                return parsedArray;
            },

            openT(t) {
                this.ticketDetails.show(t);
            },

            sortBy(field, opened) {
                if (opened) {
                    if (field == "date") {
                        if (this.openDateOrder) {
                            this.openTickets.sort((a, b) =>
                                a.date > b.date ? 1 : -1
                            );
                        } else {
                            this.openTickets.sort((a, b) =>
                                a.date < b.date ? 1 : -1
                            );
                        }
                        this.openDateOrder = !this.openDateOrder;
                        this.openIdClicked = false;
                        this.openDateClicked = true;
                    } else if (field == "id") {
                        if (this.openIdOrder) {
                            this.openTickets.sort((a, b) =>
                                a.id > b.id
                                    ? 1
                                    : a.id === b.id
                                    ? a.shortSummary > b.shortSummary
                                        ? 1
                                        : -1
                                    : -1
                            );
                        } else {
                            this.openTickets.sort((a, b) =>
                                a.id < b.id
                                    ? 1
                                    : a.id === b.id
                                    ? a.shortSummary < b.shortSummary
                                        ? 1
                                        : -1
                                    : -1
                            );
                        }
                        this.openIdOrder = !this.openIdOrder;
                        this.openIdClicked = true;
                        this.openDateClicked = false;
                    }
                } else {
                    if (field == "date") {
                        if (this.closedDateOrder) {
                            this.closedTickets.sort((a, b) =>
                                a.date > b.date ? 1 : -1
                            );
                        } else {
                            this.closedTickets.sort((a, b) =>
                                a.date < b.date ? 1 : -1
                            );
                        }
                        this.closedDateOrder = !this.closedDateOrder;
                        this.closedIdClicked = false;
                        this.closedDateClicked = true;
                    } else if (field == "id") {
                        if (this.closedIdOrder) {
                            this.closedTickets.sort((a, b) =>
                                a.id > b.id
                                    ? 1
                                    : a.id === b.id
                                    ? a.shortSummary > b.shortSummary
                                        ? 1
                                        : -1
                                    : -1
                            );
                        } else {
                            this.closedTickets.sort((a, b) =>
                                a.id < b.id
                                    ? 1
                                    : a.id === b.id
                                    ? a.shortSummary < b.shortSummary
                                        ? 1
                                        : -1
                                    : -1
                            );
                        }
                        this.closedIdOrder = !this.closedIdOrder;
                        this.closedIdClicked = true;
                        this.closedDateClicked = false;
                    }
                }
            }
        }
    };
</script>

